import React, { useState } from "react";
import { Link } from "react-router-dom";
import logvefase from "./../assets/banner/logo_habitat.jpeg";
import { FaBars, FaTimes } from "react-icons/fa";
import "./../assets/css/Header.css";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="header-jm">
      {/* Versión Desktop */}
      <div className="desktop-header">
        <div className="header-container-jm">
          <nav className="menu-left">
            <ul>
              <li><Link to="/nosotros">Nosotros</Link></li>
              <li><Link to="/servicios">Servicios</Link></li>
              <li><Link to="/productos">Productos</Link></li>
            </ul>
          </nav>
          
          <div className="logo">
            <Link to="/">
              <img src={logvefase} alt="Logo"/>
            </Link>
          </div>
          
          <nav className="menu-right">
            <ul>
              <li><Link to="/comunidad">Comunidad</Link></li>
              <li><a href="https://habitatinclusion.com/blog">Blog</a></li>
              <li><Link to="/contacto">Contacto</Link></li>
            </ul>
          </nav>
        </div>
      </div>

      {/* Versión Móvil */}
      <div className="mobile-header">
        <div className="mobile-logo">
          <Link to="/">
            <img src={logvefase} alt="Logo" />
          </Link>
        </div>
        <button className="hamburger-btn" onClick={toggleMenu}>
          {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>
      </div>

      {/* Menú Móvil */}
      {isOpen && (
        <div className="mobile-menu-overlay">
          <div className="mobile-menu-content">
            <nav>
              <ul>
                <li><Link to="/nosotros" onClick={toggleMenu}>Nosotros</Link></li>
                <li><Link to="/servicios" onClick={toggleMenu}>Servicios</Link></li>
                <li><Link to="/productos" onClick={toggleMenu}>Productos</Link></li>
                <li><Link to="/comunidad" onClick={toggleMenu}>Comunidad</Link></li>
                <li><Link to="/noticias" onClick={toggleMenu}>Noticias</Link></li>
                <li><Link to="/contacto" onClick={toggleMenu}>Contacto</Link></li>
              </ul>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;